/**
 * Популярные регионы Wordstat (id из Yandex). Полный справочник — большой;
 * в v1 показываем top-10 + возможность вписать ID руками.
 *
 * 0 — «весь мир» (используется редко). 225 — Россия (default).
 */
export interface Region {
  id: number;
  label: string;
}

export const POPULAR_REGIONS: Region[] = [
  { id: 225, label: "Россия (все регионы)" },
  { id: 213, label: "Москва" },
  { id: 2, label: "Санкт-Петербург" },
  { id: 54, label: "Свердловская область" },
  { id: 65, label: "Новосибирская область" },
  { id: 35, label: "Краснодарский край" },
  { id: 11, label: "Татарстан" },
  { id: 11111, label: "Башкортостан" },
  { id: 39, label: "Ростовская область" },
  { id: 56, label: "Челябинская область" },
];

export const DEFAULT_REGION_ID = 225;

export function findRegion(id: number): Region | undefined {
  return POPULAR_REGIONS.find((r) => r.id === id);
}

/** «Россия (225)» если в списке, иначе «Регион 12345». */
export function regionLabel(id: number): string {
  return findRegion(id)?.label ?? `Регион ${id}`;
}
